import { defineMessages } from 'react-intl'

export const scope = 'app.components.ClientComplianceTable'

/*
 * ClientComplianceTable Messages
 *
 * This contains all the text for the ClientComplianceTable component.
 */
export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the ClientComplianceTable component!',
  },
  tableHeaderOne: {
    id: `${scope}.tableHeaderOne`,
    defaultMessage: 'Event Type',
  },
  tableHeaderTwo: {
    id: `${scope}.tableHeaderTwo`,
    defaultMessage: 'Check In Type',
  },
  tableHeaderThree: {
    id: `${scope}.tableHeaderThree`,
    defaultMessage: 'Created',
  },
  tableHeaderFour: {
    id: `${scope}.tableHeaderFour`,
    defaultMessage: 'Location',
  },
  tableHeaderFive: {
    id: `${scope}.tableHeaderFive`,
    defaultMessage: 'BrAC Result',
  },
  tableHeaderSix: {
    id: `${scope}.tableHeaderSix`,
    defaultMessage: 'Zone Name',
  },
  tableHeaderSeven: {
    id: `${scope}.tableHeaderSeven`,
    defaultMessage: 'Zone Type',
  },
})
